import {Injectable} from '@angular/core';
import {UrlProviderService} from "../../../../shared/services/general";
import {FusionAuthService} from "../../../../shared/services/fusion-auth";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import {SECURED_STORE} from "../../../../shared/utils";
import {PaymentDto} from "../models/payment";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PatientBillingService {

  constructor(private urlProvider: UrlProviderService, private fusionAuthService: FusionAuthService, private router: Router, private httpClient: HttpClient) {
  }

  public getPatientIdByInvoiceSecret(secret: string) {
    return this.httpClient.get<number>(`${this.urlProvider.ApiUrl}/v2/patients/billing/invoices/${secret}/exists`, {
      reportProgress: true,
      headers: {'X-Key': environment.fusionAuth.apiKey}
    });
  }

  public patientInvoicesStore(patientIds: number[], dataSource: BehaviorSubject<DataSource>): CustomStore {
    let url = `/v2/patients/billing/invoices?`;

    patientIds.forEach((id, index) => {
      url += `patientIds=${id}`;
      if (index < patientIds.length - 1) {
        url += '&';
      }
    });

    return SECURED_STORE({
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      loadParams: null,
      dataSource,
      routerService: this.router,
      loadUrl: `${this.urlProvider.ApiUrl}${url}`,
      headers: {
        'X-Key': environment.fusionAuth.apiKey
      }
    });
  }

  public postPayment(payment: PaymentDto) {
    return this.httpClient.post<void>(`${this.urlProvider.ApiUrl}/v2/patients/billing/post-payment`, payment, {headers: {'X-Key': environment.fusionAuth.apiKey}});
  }
}
